import { Component, Host, Element, h } from '@stencil/core'

@Component({
  tag: 'cobalt-breadcrumb',
  styleUrl: 'cobalt-breadcrumb.css'
})
export class CobaltBreadcrumb {
  @Element() element!: HTMLElement

  componentDidLoad(): void {
    this.breadcrumbInit()
  }

  private readonly breadcrumbInit = (): void => {
    const breadcrumb = this.getBreadcrumb()
    if (breadcrumb.length > 1) {
      const currentItem = this.element.querySelector('span')
      breadcrumb.forEach((item) => {
        item.setAttribute('variant', 'secondary')
        item.setAttribute('size', 'medium')
      })
      currentItem.textContent = currentItem.parentElement.getAttribute('label')
      currentItem.setAttribute('class', 'current-item typography-body-medium-bold')
    }
  }

  private readonly getBreadcrumb = (): HTMLCoreBreadcrumbElement[] => {
    return Array.from(this.element.querySelectorAll('cobalt-link'))
  }

  render(): any {
    return (
      <Host>
        <core-breadcrumb>
          <slot></slot>
        </core-breadcrumb>
      </Host>
    )
  }
}
